import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import {
    registerHelperFunction,
    registerSetupCode,
    resolveBoard,
    stmt,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

let _servoUsed = false;
const _servoGlobalCodes = new Map<string, string>();

export function servoUsed(): boolean {
    return _servoUsed;
}

export function servoGlobalCodes(): Map<string, string> {
    return _servoGlobalCodes;
}

export function resetServo(): void {
    _servoUsed = false;
    _servoGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['servo_180'] = function (block: Blockly.Block): string {
        const position = block.getFieldValue('POSITION') as Position;
        const angle = Number(block.getFieldValue('ANGLE'));
        const board = resolveBoard(block);
        const pin = BOARD_CONFIG[board].pins[position].second;
        const instanceName = `_servo180_${pin}`;

        _servoUsed = true;
        _servoGlobalCodes.set(`servo_180_${pin}`, `Servo ${instanceName};\n`);
        registerSetupCode(`servo_180_${pin}`, `  ${instanceName}.attach(${pin});\n`);

        return stmt(`${instanceName}.write(${angle})`);
    };
}
